import { MessageBar, MessageBarType, ProgressIndicator } from "@fluentui/react"
import { useApiCall } from "../../hooks/apiHooks"
import { RaterForm } from "../raterDialog"

function NonUWQuoteGenerator() {
	const xrm = (window.top as any).Xrm
	const queryParameters = new URLSearchParams(window.top.location.search)
	const oppIdQueryParam = queryParameters.get("id")

	const {
		data: opp,
		loading: loadingOpp,
		error: errorLoadingOpp
	} = useApiCall<any>(`/opportunities(${oppIdQueryParam})?$select=opportunityid&$expand=parentaccountid($select=*)`, {
		customApiPath: "api/data/v9.2.24042.218",
		customApiBaseUrl: `https://${window.top.location.hostname}`,
		method: "GET",
		refetchOnChanges: [oppIdQueryParam],
		canFetch: !!oppIdQueryParam
	})

	return (
		<div>
			{loadingOpp && <ProgressIndicator label="Loading opportunity..." />}
			{errorLoadingOpp && <MessageBar messageBarType={MessageBarType.error}>{errorLoadingOpp}</MessageBar>}
			{opp?.parentaccountid && (
				<RaterForm
					group={opp.parentaccountid}
					onDismiss={() => {
						/*VOID*/
					}}
					isCRM
				/>
			)}
			{!opp?.parentaccountid && <MessageBar messageBarType={MessageBarType.warning}>No group found for this opportunity. Please ensure the opportunity is associated with a group.</MessageBar>}
		</div>
	)
}

export default NonUWQuoteGenerator
